export const selfProjectUrl = process.env.REACT_APP_DOMAIN_URL;
export const pudralUrl = process.env.REACT_APP_PUDRAL_URL;
